export default __webpack_public_path__ + "static/media/google-logo.9a818e61.png";